import React from "react";

const History = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M18.8 3C13.2 3 8.24 6.022 5.68 10.635L2 6.977v10.339h10.4l-4.48-4.454C10 8.885 14 6.182 18.8 6.182c6.56 0 12 5.407 12 11.93 0 6.52-5.44 11.929-12 11.929-5.28 0-9.6-3.34-11.36-7.953H4.08c1.76 6.362 7.68 11.134 14.72 11.134 8.48 0 15.2-6.84 15.2-15.11C34 9.84 27.12 3 18.8 3zm-2.4 7.953v8.113l7.52 4.453 1.28-2.067-6.4-3.818v-6.68h-2.4z"
          fill={fill}
      />
    </svg>
);

export default History;
